import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import MosCatButton from '@mos-cat/button';
import Spinner from '@mos-front-components/public/es/components/Spinner';

import './Button.pcss';

const Button = props => {
  const { children, progress, type, className } = props;
  const classNames = cn([
    className,
    'Button',
    {
      'Button--progress': progress
    },
    {
      'Button--link': type === 'link'
    },
    {
      'Button--link Button--inline-link': type === 'inline-link'
    }
  ]);

  return (
    <MosCatButton
      {...props}
      progress={progress ? 'true' : 'false'}
      className={classNames}
    >
      {progress && <Spinner />}
      {children}
    </MosCatButton>
  );
};

Button.propTypes = {
  progress: PropTypes.bool,
  disabled: PropTypes.bool,
  primary: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.oneOf(['small', 'standard', 'big']),
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Button;
